module.exports = __webpack_public_path__ + "img/color_block_7.56562ee5.svg";